import React from 'react'
// libs
import { useDispatch, useSelector } from 'react-redux'
import { change, formValueSelector } from 'redux-form'
// hooks
import { Image, useImageUpload } from 'hooks/useImageUpload'
// types
import { AssetType } from 'types/graphql'
// icons
import AddCircle from '@mui/icons-material/AddCircle'
// themes
import colors from 'themes/colors'
// constants
import { Forms } from 'constants/forms'
import { ALLOWED_IMAGE_TYPES } from 'utils/validators'
// store
import { currentDashboardSelector } from 'store/reducers/dashboards'
// views
import { AddFieldButtonWrapper } from 'components/PageComponents/Home/components/AddItemButton/views'
import { CloseIcon, Link, LinkWrapper } from './views'

const INPUT_STYLES = { display: 'none' }

interface Props {
  name: string
}

const UploadImage: React.FC<Props> = ({ name }) => {
  const dispatch = useDispatch()

  const currentDashboard = useSelector(currentDashboardSelector)

  const defaultImage = useSelector((state) => formValueSelector(Forms.DASHBOARD_WIDGET_SETTINGS_FORM)(state, name))

  const onUpload = (image: Image) => dispatch(change(Forms.DASHBOARD_WIDGET_SETTINGS_FORM, name, image))

  const { image, onFileUpload } = useImageUpload({
    onUpload,
    assetType: AssetType.ActivityFile,
    entityPrefix: `entity/${currentDashboard.id}/assets`
  })

  const inputFileRef = React.useRef<HTMLInputElement>(null)

  const onUploadClick = () => inputFileRef.current.click()

  const clearField = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation()
    dispatch(change(Forms.DASHBOARD_WIDGET_SETTINGS_FORM, name, null))
  }

  const img = defaultImage || image

  if (img) {
    return (
      <LinkWrapper>
        <Link target='_blank' href={img.url}>
          {img.name}
        </Link>
        <CloseIcon onClick={clearField} />
      </LinkWrapper>
    )
  }

  return (
    <>
      <AddFieldButtonWrapper onClick={onUploadClick}>
        <AddCircle htmlColor={colors.blue500} />
        <span>Add image</span>
      </AddFieldButtonWrapper>
      <input
        id='file'
        type='file'
        ref={inputFileRef}
        style={INPUT_STYLES}
        onChange={onFileUpload}
        accept={ALLOWED_IMAGE_TYPES.join(',')}
      />
    </>
  )
}

export default UploadImage
